<template>
  <div class="b1">
    <div class="flex_between_nowrap">
      <span class="title_before side_title">盘点审批</span>
    </div>
    <div style="padding:0px 20px 0px 24px">
      <!-- <div
        class="flex_between_nowrap"
        style="margin-top:20px;margin-bottom:30px"
      >
        <div>
          <el-input
            clearable
            placeholder="请输入单号/组织/使用人"
            size="small"
            v-model="params['search']"
            style="width:300px;"
          >
            <i
              slot="suffix"
              class="el-icon-search inputIcon "
              @click.stop="tableSearch"
            ></i>
          </el-input>
        </div>
        <div class="flex_end">
          <el-button type="submit" @click="add_click">新增</el-button>
        </div>
      </div> -->
      <x-table
        url="/pc/pdexamine/page"
        ref="xTable"
        style="margin-top:30px"
        :params="params"
      >
        <el-table-column
          :label="item.label"
          :prop="item.model"
          show-overflow-tooltip
          v-for="item in columnArr"
          :key="item.model"
          ><template slot-scope="scope">
            <el-tag
              :style="checkResultFulter(scope.row[item.model], false)"
              v-if="item.model == 'checkResult'"
              >{{ checkResultFulter(scope.row[item.model], true) }}</el-tag
            >
            <el-tag
              :style="checkStatusFulter(scope.row[item.model], false)"
              v-else-if="item.model == 'checkStatus'"
              >{{ checkStatusFulter(scope.row[item.model], true) }}</el-tag
            >

            <span v-else>{{ scope.row[item.model] }}</span>
          </template>
        </el-table-column>

        <el-table-column label="操作" fixed="right" width="200" align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              class="addColor"
              @click="
                $router.push({
                  path: `/pd/examine`,
                  query: { id: scope.row.id },
                })
              "
              >审批</el-button
            >
          </template>
        </el-table-column>
      </x-table>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      params: {},
      pdresult: [
        {
          label: "未盘",
          model: "not",
          style: "color:#436bff;background:#d8e6ff;",
        },
        {
          label: "盘亏",
          model: "little",
          style: "color:#fa675c;background:#ffd0cc;",
        },
        {
          label: "正常",
          model: "normal",
          style: "color:#42b983;background:#f0f9eb;",
        },
        {
          label: "盘盈",
          model: "more",
          style: "color:#ffa200;background:#ffefd8;",
        },
      ],
      statusArr: [
        {
          label: "未盘",
          model: "not",
          style: "color:#436bff;background:#d8e6ff;",
        },
        {
          label: "盘点中",
          model: "await",
          style: "color:#436bff;background:#d8e6ff;",
        },
        {
          label: "等待审核",
          model: "examine",
          style: "color:#ffa200;background:#ffefd8;",
        },
        {
          label: "完成",
          model: "end",
          style: "color:#42b983;background:#f0f9eb;",
        },
      ],
      columnArr: [
        {
          label: "盘点标题",
          model: "checkTitle",
        },
        {
          label: "盘点状态",
          model: "checkStatus",
        },
        {
          label: "盘点结果",
          model: "checkResult",
        },
        {
          label: "盘点部门",
          model: "deptName",
        },
        {
          label: "盘点人",
          model: "checkUserName",
        },
        {
          label: "应盘资产数量",
          model: "shouldGoodsCount",
        },
        {
          label: "实盘资产数量",
          model: "actualGoodsCount",
        },
        {
          label: "资产金额",
          model: "price",
        },
        {
          label: "实盘资产金额",
          model: "actualPrice",
        },
        {
          label: "盘点时间",
          model: "pdTime",
        },
      ],
    };
  },
  mounted() {},
  methods: {
    checkResultFulter(data, flag) {
      let a = "";
      for (let i = 0; i < this.pdresult.length; i++) {
        if (this.pdresult[i].model == data) {
          a = flag ? this.pdresult[i].label : this.pdresult[i].style;
          break;
        }
      }
      return a;
    },
    checkStatusFulter(data, flag) {
      let a = "";
      for (let i = 0; i < this.statusArr.length; i++) {
        if (this.statusArr[i].model == data) {
          a = flag ? this.statusArr[i].label : this.statusArr[i].style;
          break;
        }
      }
      return a;
    },
    examine(id) {
      this.$createDialog(this, {
        dialogConfig: { title: "盘点审批", width: "360px" },
        namespace: "pd_task_examine",
        whetherDestruction: true,

        assemblyConfig: {
          id,
          callBack: this.tableSearch,
        },
      });
    },
    tableSearch() {
      this.$refs.xTable.search();
    },
  },
};
</script>
<style scoped></style>
